import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  ArticleList,
  ArticleListItemImage,
  ContactsBlock,
  Pagination,
  SearchBlock,
  SideBar,
} from '@lanl-web/lanl-components';

import { getImageUrl, slugify } from '../../utils';

import './DocsList.scss';

export const DocsList = ({ alt, contactEmail, contactName, docs, title }) => {
  const [docsDisplay, setDocsDisplay] = useState(docs);

  const renderContact = () => {
    return (
      contactEmail && (
        <ContactsBlock
          dividerTop
          contacts={[{ email: contactEmail, name: contactName }]}
        />
      )
    );
  };

  return (
    <div className='docs-list' id='pagination-top'>
      <ArticleList>
        {docsDisplay.map(({ link, image, subtitle, title }) => (
          <ArticleListItemImage
            alt={title}
            key={`article-list-${slugify(title)}`}
            href={link}
            image={getImageUrl(image)}
            subtitle={subtitle}
            title={title}
          />
        ))}
        <Pagination data={docs} pageSize={10} onPageChange={setDocsDisplay} />
      </ArticleList>

      <SideBar>
        <SearchBlock title={title} dividerTop />
        {renderContact()}
      </SideBar>
    </div>
  );
};

DocsList.propTypes = {
  docs: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  alt: PropTypes.string,
  contactEmail: PropTypes.string,
  contactName: PropTypes.string,
};

DocsList.defaultProps = {
  alt: 'Ceased Publications',
};

DocsList.defaultProps = {
  alt: 'Ceased Publications',
};

export default DocsList;
